import axios, { encodeData } from "../utils/axios";

export function externalSignIn(credentials) {
  return new Promise((resolve, reject) => {
    axios
      .post("/external-users/login", encodeData(credentials))
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }

        reject(response.data);
      })
      .catch((error) => {
        reject(error?.response?.data || error);
      });
  });
}

export function internalSignIn(credentials) {
  return new Promise((resolve, reject) => {
    axios
      .post("/internal-users/login", encodeData(credentials))
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }

        reject(response.data);
      })
      .catch((error) => {
        reject(error?.response?.data || error);
      });
  });
}

export function signUp(credentials) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/auth/sign-up", encodeData(credentials))
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function resetPassword(credentials) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/auth/reset-password", encodeData(credentials))
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function internalAuthSignInPortAuth(code) {
  return new Promise((resolve, reject) => {
    axios
      .get("/internal-users/tokenAndUserInfo", { params: { code: code } })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error?.response?.data || error);
      });
  });
}

export function dummyInternalAuthSignInPortAuth(code) {
  // console.log("dummyInternalAuthSignInPortAuth axios " + code)
  return new Promise((resolve, reject) => {
    axios
      .get("/internal-users/dummyLogin", { params: { code: code } })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
        // console.log("dummyInternalAuthSignInPortAuth " + response.data);
      })
      .catch((error) => {
        // console.log("dummyInternalAuthSignInPortAuth error " + error);
        reject(error?.response?.data || error);
      });
  });
}

export function externalAuthSignInCitizen(code) {
  return new Promise((resolve, reject) => {
    axios
      .get("/external-users/tokenAndUserInfo", { params: { code: code } })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error?.response?.data || error);
      });
  });
}
